export default function genererLigneCommandeDispositif() {
  return {
    dispositifSupportId: null,
    dispositifTypeId: null,
    materielTypeId: null,
    materielFormatId: null,
    isDoubleFace: false,
    materielEclaire: false,
    longueur: 0,
    largeur: 0,
    nomenclature: null,
    nomenclatureTypeId: null,
  };
}
